/** Altura da logo em headers de fluxo (cadastro, login, etc.). */
export const BRAND_FLOW_LOGO_SIZE = 32

/** Altura da logo em footer e sidebar compacto. */
export const BRAND_COMPACT_LOGO_SIZE = 28

interface AstraLogoProps {
  className?: string
  /** Altura visual da logo em px. */
  size?: number
  variant?: "light" | "dark" | "dark-on-dark"
}

const LOGO_SRC: Record<NonNullable<AstraLogoProps["variant"]>, string> = {
  light: "/brand/logo-astra-energia-white.svg",
  dark: "/brand/logo-astra-energia.svg",
  "dark-on-dark": "/brand/logo-astra-energia.svg",
}

/** Proporção após crop do viewBox em cada SVG em public/brand/. */
const LOGO_ASPECT: Record<NonNullable<AstraLogoProps["variant"]>, number> = {
  dark: 1371 / 206,
  "dark-on-dark": 1371 / 206,
  light: 1251 / 188,
}

/** 32px a partir de 360px e 28px abaixo, para caber com alvos de 44px. */
export function AstraLogoResponsive({
  className = "",
  variant = "light",
  size = BRAND_FLOW_LOGO_SIZE,
  compactSize = BRAND_COMPACT_LOGO_SIZE,
}: {
  className?: string
  variant?: AstraLogoProps["variant"]
  size?: number
  compactSize?: number
}) {
  return (
    <>
      <span className={`hidden min-[360px]:block ${className}`}>
        <AstraLogo variant={variant} size={size} />
      </span>
      <span className={`block min-[360px]:hidden ${className}`}>
        <AstraLogo variant={variant} size={compactSize} />
      </span>
    </>
  )
}

export function AstraLogo({ className = "", size = 40, variant = "dark" }: AstraLogoProps) {
  const height = size
  const width = Math.round(size * LOGO_ASPECT[variant])

  return (
    // eslint-disable-next-line @next/next/no-img-element -- SVG estático de marca
    <img
      src={LOGO_SRC[variant]}
      alt="Astra Energia"
      width={width}
      height={height}
      className={`block h-auto max-w-none ${className}`}
      style={{ width, height }}
      decoding="async"
    />
  )
}

export function AstraLogoIcon({ className = "", size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      viewBox="0 0 57.4 57.4"
      fill="none"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={`text-primary ${className}`}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H57.4V46.7122L52.7051 35.591H36.5571L44.3663 54.0914H57.4V57.4H0V0ZM51.8921 33.4344L44.0817 14.9344H27.9341L35.743 33.4344H51.8921ZM26.5084 54.0914L34.3177 35.591H18.1685L10.3593 54.0914H26.5084Z"
        fill="currentColor"
      />
    </svg>
  )
}
